export const CLIENTID    ='9lpV5JUz2lcZZCmSN0_SYg';
export const CLIENTSECRET='Yj4SyrYTPdW6_VfnQ8oT0KXnwAYNeg';
export const REFRESHTOKEN='1070546588707-E93yrhGR0Dfcj5L6Xxx_jEnuIxN-Lg';